export const COURSES = [
  'JEE - Integrated 26-28',
  'NEET Integrated 26-28',
  'JEE Repeater 26-27',
  'NEET Repeater 26-27',
];

export const CALL_STATUS = {
  CONNECTED: 'connected',
  NOT_CONNECTED: 'not_connected',
};

export function normalizeCourses(course) {
  if (Array.isArray(course)) return course;
  return course ? [course] : [];
}
